// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"1c69322d","350":"d89ae8d3","360":"f2ae547d","445":"9d11256a","453":"e67b519e","455":"766972e6","536":"f04d3ab8","746":"9da9b25b","827":"cbf165f3","944":"31df91be","977":"2626d0aa","994":"4f84371a"}[chunkId] + ".chunk.js";
};